// Classifies a client route into a resumable "work" location, or null when the
// route is not worth resuming (home, browse, listings, auth, profile, admin...).
//
// "Work" = looking at a specific book (editing/reading) or a translation project.

export type LastLocationKind = 'book' | 'translation';

export function classifyLocation(pathname: string): { kind: LastLocationKind } | null {
  const translate = pathname.match(/^\/translate\/([^/]+)/);
  if (translate && translate[1]) {
    return { kind: 'translation' };
  }

  const book = pathname.match(/^\/books\/([^/]+)/);
  if (book) {
    const segment = book[1];
    // Listing / creation routes target no specific book — not resumable.
    if (segment === 'new' || segment === 'drafts') return null;
    return { kind: 'book' };
  }

  return null;
}

// Pulls the book or translation project id out of a resumable path. The path may
// carry a query string/hash (we record those to preserve view state), so strip
// them before matching the id.
export function idFromLocation(path: string): string | null {
  const pathname = path.split(/[?#]/)[0];
  const translate = pathname.match(/^\/translate\/([^/]+)/);
  if (translate) return translate[1];
  const book = pathname.match(/^\/books\/([^/]+)/);
  if (book) return book[1];
  return null;
}
